module.exports = __webpack_public_path__ + "static/img/4.f822058.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-trans-mercancias-especifico/4.png
// module id = on4S
// module chunks = 0